var CrossshowEvent = {}

CrossshowEvent.Get_Cross_Show_Info_Event = "Get_Cross_Show_Info_Event"

module.exports = CrossshowEvent